import React from 'react';
import PageShell from '../../components/PageShell';
import { SectionHeading, GradientButton, InfoCard } from '../../components/common/Primitives';
import { CAREERS_LIST } from '../../lib/mock2';
import { ArrowRight } from 'lucide-react';

export default function Careers() {
  const submit = (e) => { e.preventDefault(); alert('Application submitted (mock). It will be emailed to the team in the full build.'); };
  return (
    <PageShell>
      <section className="px-6 pt-12 pb-8">
        <div className="mx-auto max-w-[1240px]">
          <h1 className="text-[42px] md:text-[52px] font-extrabold leading-[1.06] tracking-tight text-navy">Careers at Gyan Dhara</h1>
          <p className="mt-5 max-w-2xl text-[15.5px] leading-relaxed text-ink-500">Join a multidisciplinary team building immersive, experiential &amp; wholistic learning for schools.</p>
        </div>
      </section>

      <section className="px-6 py-16">
        <div className="mx-auto max-w-[1240px]">
          <SectionHeading eyebrow="OPEN ROLES" title="Current opportunities" />
          <div className="mt-8 gap-5">
            <div className="rounded-2xl border border-dashed border-canvas-200 bg-white p-8 text-center shadow-soft">
              <div className="text-[15px] font-bold text-navy">No current opportunities</div>
              <p className="mt-2 text-[13px] text-ink-500">Open roles are announced here when applications are being accepted. Please check back later or write to us if you would like to be informed of upcoming openings.</p>
              <div className="mt-4"><GradientButton to="/contact" variant="outline">Contact the Team</GradientButton></div>
            </div>
          </div>
        </div>
      </section>

      <section className="px-6 py-16 bg-white">
        <div className="mx-auto max-w-[1240px]">
          <SectionHeading eyebrow="WORKING WITH US" title="What contributors work on" desc="VR learning modules, impact assessment, field research, UX design, 3D production, and school deployment." />
          <div className="mt-8 grid grid-cols-1 gap-4 md:grid-cols-3">
            <InfoCard icon="Target" color="purple" title="Education impact" desc="Work on meaningful classroom problems." />
            <InfoCard icon="Users2" color="royal" title="Multidisciplinary practice" desc="Collaborate across design, research and development." />
            <InfoCard icon="School" color="mint" title="School-based learning" desc="Test and improve work in real contexts." />
          </div>
        </div>
      </section>

      <section className="px-6 py-16 pb-24">
        <div className="mx-auto max-w-[1240px]">
          <SectionHeading eyebrow="APPLICATION" title="Apply to an active role" desc="The generic application form is retained only when relevant, not on the homepage." />
          <form onSubmit={submit} className="mt-8 rounded-2xl border border-canvas-200 bg-white p-6 md:p-8 shadow-soft grid grid-cols-1 gap-5 md:grid-cols-2">
            <label className="block"><span className="text-[12.5px] text-ink-500">Full name</span><input className="mt-1 w-full rounded-lg border border-canvas-200 px-3 py-2.5 text-[13.5px] focus:border-purple" required /></label>
            <label className="block"><span className="text-[12.5px] text-ink-500">Email</span><input type="email" className="mt-1 w-full rounded-lg border border-canvas-200 px-3 py-2.5 text-[13.5px] focus:border-purple" required /></label>
            <label className="block"><span className="text-[12.5px] text-ink-500">Position applying for</span><input className="mt-1 w-full rounded-lg border border-canvas-200 px-3 py-2.5 text-[13.5px] focus:border-purple" /></label>
            <label className="block"><span className="text-[12.5px] text-ink-500">Portfolio link</span><input className="mt-1 w-full rounded-lg border border-canvas-200 px-3 py-2.5 text-[13.5px] focus:border-purple" /></label>
            <label className="block md:col-span-1"><span className="text-[12.5px] text-ink-500">Why do you want to join Gyan Dhara?</span><textarea rows={4} className="mt-1 w-full rounded-lg border border-canvas-200 px-3 py-2.5 text-[13.5px] focus:border-purple" /></label>
            <label className="block md:col-span-1"><span className="text-[12.5px] text-ink-500">CV or résumé</span>
              <div className="mt-1 rounded-lg border border-dashed border-canvas-200 bg-canvas-100 hover:border-purple transition-colors">
                <input type="file" accept=".pdf,.doc,.docx" className="block w-full cursor-pointer px-3 py-6 text-[13px] text-ink-500 file:mr-4 file:rounded-md file:border-0 file:bg-brand-gradient file:px-4 file:py-2 file:text-[12.5px] file:font-semibold file:text-white hover:file:brightness-110" />
              </div>
            </label>
            <div className="md:col-span-2"><button className="rounded-lg bg-brand-gradient px-5 py-2.5 text-[13.5px] font-semibold text-white shadow-soft">Submit Application</button></div>
          </form>
        </div>
      </section>
    </PageShell>
  );
}
